<template>
    <h1>
        <slot></slot>
    </h1>
</template>
<style scoped>
h1 {
    height: 50px;
    line-height: 50px;
    padding: 0 0;
    color: #43484e;
}
</style>
<script>
export default {
    name: 'PageTitle'
}
</script>
